module.exports = __webpack_public_path__ + "img/pro_capture11.10b0d39c.png";